import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PAnnouncementManagementViewComponent } from './views/p-announcement-management-view/p-announcement-management-view.component';
import { SharedModule } from '@shared/shared.module';
import { MultiLanguageModule } from '@/app/multi-language.module';



@NgModule({
  declarations: [
    PAnnouncementManagementViewComponent
  ],
  exports: [
    PAnnouncementManagementViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MultiLanguageModule
  ]
})
export class NotificationManagementModuleModule { }
